const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/portfolios',
  component: Module,
  children: [
    {
      path: '/',
      name: 'portfolios',
      component: Home,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
